/**
 * Tab Component
 *
 * @file tab.js
 */
import $ from "jquery";

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
  };

  const homesolutionTab = () => {
    $(".hm-sol-item").hover(function(){
      var thLink = $(this).data("href");
      var thBg = $(this).data("background");
      $(".hm-sol-bg").fadeOut(250, function () {
        $(".hm-sol-bg").css("background-image", "url('" + thBg + "')");
        $(".hm-sol-bg").fadeIn(250);
      });
      $(".hm-sol-name").html($(this).html());
      $(".hm-sol-link").attr("href", thLink);
    }, function(){

    });
  };

  const init = () => {
    defaultTab();
    homesolutionTab();
  };

  return {
    init,
  };
})();

export default tabs;
